<template>
  <div class="financing-form">
    <div class="header">
      <h1>个人咨询表</h1>
    </div>

    <form class="form-container" id="financeForm" @submit.prevent="handleSubmit">
      <!-- 申请人信息 -->
      <div class="section">
        <div class="section-title">申请人信息</div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">姓名</label>
            <input type="text" class="form-input" v-model="formData.name" placeholder="请输入姓名">
          </div>
          <div class="form-item">
            <label class="form-label">联系电话</label>
            <input type="tel" class="form-input" v-model="formData.phone" placeholder="请输入联系电话">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">性别</label>
            <select class="form-input" v-model="formData.gender">
              <option value="">请选择</option>
              <option value="男">男</option>
              <option value="女">女</option>
            </select>
          </div>
          <div class="form-item">
            <label class="form-label">出生年月</label>
            <input type="month" class="form-input" v-model="formData.birthDate">
          </div>
          <div class="form-item">
            <label class="form-label">民族</label>
            <input type="text" class="form-input" v-model="formData.ethnicity" placeholder="请输入民族">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">学历</label>
            <select class="form-input" v-model="formData.education">
              <option value="">请选择</option>
              <option value="高中及以下">高中及以下</option>
              <option value="大专">大专</option>
              <option value="本科">本科</option>
              <option value="硕士">硕士</option>
              <option value="博士">博士</option>
            </select>
          </div>
          <div class="form-item">
            <label class="form-label">婚姻状况</label>
            <div class="radio-group">
              <label class="radio-item">
                <input type="radio" v-model="formData.maritalStatus" value="已婚"> 已婚
              </label>
              <label class="radio-item">
                <input type="radio" v-model="formData.maritalStatus" value="未婚"> 未婚
              </label>
              <label class="radio-item">
                <input type="radio" v-model="formData.maritalStatus" value="离异"> 离异
              </label>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-item full-width">
            <label class="form-label">身份证号</label>
            <input type="text" class="form-input" v-model="formData.idCard" placeholder="请输入身份证号" maxlength="18">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">户口所在地</label>
            <input type="text" class="form-input" v-model="formData.householdPlace" placeholder="请输入户口所在地">
          </div>
          <div class="form-item">
            <label class="form-label">邮箱</label>
            <input type="email" class="form-input" v-model="formData.email" placeholder="请输入邮箱">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item full-width">
            <label class="form-label">家庭住址</label>
            <input type="text" class="form-input" v-model="formData.homeAddress" placeholder="请输入家庭住址">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item full-width">
            <label class="form-label">工作单位</label>
            <input type="text" class="form-input" v-model="formData.workUnit" placeholder="请输入工作单位">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">单位性质</label>
            <select class="form-input" v-model="formData.unitNature">
              <option value="">请选择</option>
              <option value="国企">国企</option>
              <option value="私企">私企</option>
              <option value="外企">外企</option>
              <option value="事业单位">事业单位</option>
              <option value="政府机关">政府机关</option>
              <option value="个体">个体</option>
              <option value="其他">其他</option>
            </select>
          </div>
          <div class="form-item">
            <label class="form-label">单位电话</label>
            <input type="tel" class="form-input" v-model="formData.unitPhone" placeholder="请输入单位电话">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">职务</label>
            <input type="text" class="form-input" v-model="formData.position" placeholder="请输入职务">
          </div>
          <div class="form-item">
            <label class="form-label">单位地址</label>
            <input type="text" class="form-input" v-model="formData.unitAddress" placeholder="请输入单位地址">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">申请金额（万元）</label>
            <input type="number" class="form-input" v-model="formData.applyAmount" placeholder="请输入申请金额">
          </div>
          <div class="form-item">
            <label class="form-label">申请期限（月）</label>
            <input type="number" class="form-input" v-model="formData.applyTerm" placeholder="请输入申请期限">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">银行及网贷</label>
            <input type="text" class="form-input" v-model="formData.bankAndLoan" placeholder="请输入银行及网贷">
          </div>
          <div class="form-item">
            <label class="form-label">信用卡张数</label>
            <input type="number" class="form-input" v-model="formData.creditCardCount" placeholder="请输入信用卡张数">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item full-width">
            <label class="form-label">总额度及银行</label>
            <input type="text" class="form-input" v-model="formData.totalLimitAndBank" placeholder="请输入总额度及银行">
          </div>
        </div>
      </div>

      <!-- 配偶信息 -->
      <div class="section">
        <div class="section-title">配偶信息</div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">姓名</label>
            <input type="text" class="form-input" v-model="formData.spouseName" placeholder="请输入配偶姓名">
          </div>
          <div class="form-item">
            <label class="form-label">电话</label>
            <input type="tel" class="form-input" v-model="formData.spousePhone" placeholder="请输入配偶电话">
          </div>
        </div>
      </div>

      <!-- 紧急联系人 -->
      <div class="section">
        <div class="section-title">紧急联系人</div>
        <div class="emergency-contact">
          <div class="emergency-contact-title">联系人 1</div>
          <div class="form-row">
            <div class="form-item">
              <label class="form-label">姓名</label>
              <input type="text" class="form-input" v-model="formData.emergency1Name" placeholder="请输入姓名">
            </div>
            <div class="form-item">
              <label class="form-label">关系</label>
              <input type="text" class="form-input" v-model="formData.emergency1Relation" placeholder="请输入关系">
            </div>
          </div>
          <div class="form-row">
            <div class="form-item full-width">
              <label class="form-label">联系电话</label>
              <input type="tel" class="form-input" v-model="formData.emergency1Phone" placeholder="请输入联系电话">
            </div>
          </div>
        </div>
        <div class="emergency-contact">
          <div class="emergency-contact-title">联系人 2</div>
          <div class="form-row">
            <div class="form-item">
              <label class="form-label">姓名</label>
              <input type="text" class="form-input" v-model="formData.emergency2Name" placeholder="请输入姓名">
            </div>
            <div class="form-item">
              <label class="form-label">关系</label>
              <input type="text" class="form-input" v-model="formData.emergency2Relation" placeholder="请输入关系">
            </div>
          </div>
          <div class="form-row">
            <div class="form-item full-width">
              <label class="form-label">联系电话</label>
              <input type="tel" class="form-input" v-model="formData.emergency2Phone" placeholder="请输入联系电话">
            </div>
          </div>
        </div>
        <div class="emergency-contact">
          <div class="emergency-contact-title">联系人 3</div>
          <div class="form-row">
            <div class="form-item">
              <label class="form-label">姓名</label>
              <input type="text" class="form-input" v-model="formData.emergency3Name" placeholder="请输入姓名">
            </div>
            <div class="form-item">
              <label class="form-label">关系</label>
              <input type="text" class="form-input" v-model="formData.emergency3Relation" placeholder="请输入关系">
            </div>
          </div>
          <div class="form-row">
            <div class="form-item full-width">
              <label class="form-label">联系电话</label>
              <input type="tel" class="form-input" v-model="formData.emergency3Phone" placeholder="请输入联系电话">
            </div>
          </div>
        </div>
      </div>

      <!-- 经济情况 -->
      <div class="section">
        <div class="section-title">经济情况</div>

        <div class="sub-section">房产情况</div>
        <div class="form-row">
          <div class="form-item full-width">
            <label class="form-label">房产地址</label>
            <input type="text" class="form-input" v-model="formData.propertyAddress" placeholder="请输入房产地址">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">建筑面积（㎡）</label>
            <input type="number" class="form-input" v-model="formData.buildingArea" placeholder="请输入建筑面积">
          </div>
          <div class="form-item">
            <label class="form-label">月还款及年限</label>
            <input type="text" class="form-input" v-model="formData.monthlyPaymentAndTerm" placeholder="请输入月还款及年限">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item full-width">
            <label class="form-label">购房方式</label>
            <div class="radio-group">
              <label class="radio-item">
                <input type="radio" v-model="formData.purchaseType" value="全款"> 全款
              </label>
              <label class="radio-item">
                <input type="radio" v-model="formData.purchaseType" value="按揭"> 按揭
              </label>
            </div>
          </div>
        </div>

        <div class="sub-section">其他资产</div>
        <div class="form-row">
          <div class="form-item full-width">
            <label class="form-label">车产</label>
            <input type="text" class="form-input" v-model="formData.vehicle" placeholder="请输入车产信息">
          </div>
        </div>

        <div class="sub-section">社保公积金</div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">社保</label>
            <div class="radio-group">
              <label class="radio-item">
                <input type="radio" v-model="formData.socialSecurity" value="有"> 有
              </label>
              <label class="radio-item">
                <input type="radio" v-model="formData.socialSecurity" value="无"> 无
              </label>
            </div>
          </div>
          <div class="form-item">
            <label class="form-label">基数</label>
            <input type="number" class="form-input" v-model="formData.socialSecurityBase" placeholder="请输入基数">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">年限</label>
            <input type="number" class="form-input" v-model="formData.socialSecurityYears" placeholder="请输入年限">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">公积金</label>
            <div class="radio-group">
              <label class="radio-item">
                <input type="radio" v-model="formData.housingFund" value="有"> 有
              </label>
              <label class="radio-item">
                <input type="radio" v-model="formData.housingFund" value="无"> 无
              </label>
            </div>
          </div>
          <div class="form-item">
            <label class="form-label">个缴金额</label>
            <input type="number" class="form-input" v-model="formData.housingFundAmount" placeholder="请输入个缴金额">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">年限</label>
            <input type="number" class="form-input" v-model="formData.housingFundYears" placeholder="请输入年限">
          </div>
        </div>

        <div class="sub-section">收入情况</div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">打卡工资</label>
            <input type="number" class="form-input" v-model="formData.salary" placeholder="请输入打卡工资">
          </div>
          <div class="form-item">
            <label class="form-label">配偶收入</label>
            <input type="number" class="form-input" v-model="formData.spouseIncome" placeholder="请输入配偶收入">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label class="form-label">公司开票</label>
            <input type="text" class="form-input" v-model="formData.companyInvoice" placeholder="请输入公司开票">
          </div>
          <div class="form-item">
            <label class="form-label">对外担保</label>
            <input type="text" class="form-input" v-model="formData.externalGuarantee" placeholder="请输入对外担保">
          </div>
        </div>
        <div class="form-row">
          <div class="form-item full-width">
            <label class="form-label">保单</label>
            <input type="text" class="form-input" v-model="formData.insurancePolicy" placeholder="请输入保单信息">
          </div>
        </div>

        <div class="form-row">
          <div class="form-item full-width">
            <label class="form-label">是否对婚前后财产归属有公证约定</label>
            <div class="radio-group">
              <label class="radio-item">
                <input type="radio" v-model="formData.propertyNotarization" value="是"> 是
              </label>
              <label class="radio-item">
                <input type="radio" v-model="formData.propertyNotarization" value="否"> 否
              </label>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-item full-width">
            <label class="form-label">个人征信</label>
            <div class="radio-group">
              <label class="radio-item">
                <input type="radio" v-model="formData.creditStatus" value="好"> 好
              </label>
              <label class="radio-item">
                <input type="radio" v-model="formData.creditStatus" value="一般"> 一般
              </label>
              <label class="radio-item">
                <input type="radio" v-model="formData.creditStatus" value="较差"> 较差
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- 贷款用途 -->
      <div class="section">
        <div class="section-title">贷款用途</div>
        <div class="loan-purpose">
          本人因<input type="text" v-model="formData.loanReason" placeholder="用途">需要，向贵公司申请贷款咨询<input type="text" v-model="formData.loanAmount" placeholder="金额">万元，期限<input type="text" v-model="formData.loanTerm" placeholder="期限">个月，担保方式是<input type="text" v-model="formData.guaranteeMethod" placeholder="担保方式">，请予以考虑。
        </div>
      </div>

      <!-- 注意事项 -->
      <div class="section">
        <div class="section-title">注意事项</div>
        <div class="notes-section">
          <div class="note-item">
            <span class="note-label">面签：</span>
            <span>面签前删除掉手机里有赌博性质的APP、借款APP，面签官会问贷款用途、单位地址、名称、家庭住址等。</span>
          </div>
          <div class="note-item">
            <span class="note-label">电审：</span>
            <span>电审前确认好手机有无骚扰电话拦截功能，拦截APP有的话一定要关闭、删除。</span>
          </div>
          <div class="note-item">
            <span class="note-label">下户：</span>
            <span>企业主、股东下户单位，提前给下户核访老师准备好饮料、茶、烟，这是加分项，单位需要有招牌，提前准备好经营往来合同、票据、流水，准备的越齐全越稳。</span>
          </div>
        </div>
      </div>

      <!-- 接待经理 -->
      <div class="section">
        <div class="section-title">接待经理</div>
        <div class="signature-row">
          <div class="form-item full-width">
            <label class="form-label">客户经理工号</label>
            <input type="text" class="form-input" v-model="formData.managerSign" placeholder="请输入客户经理工号">
          </div>
        </div>
      </div>

      <button type="submit" class="submit-btn" :disabled="submitting">
        {{ submitting ? '提交中...' : '提交申请' }}
      </button>
    </form>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import { ElMessage } from "element-plus";
import { postCustomerVisit } from "@/api/method/customer-visit";
import router from "../../router";

const genRow = (label, value) =>
  `<div class="form-row"><div class="form-item full-width"><label class="form-label">${label}</label><span>${value || ""}</span></div></div>`;

const genDoubleRow = (label1, value1, label2, value2) =>
  `<div class="form-row"><div class="form-item"><label class="form-label">${label1}</label><span>${value1 || ""}</span></div><div class="form-item"><label class="form-label">${label2}</label><span>${value2 || ""}</span></div></div>`;

const genRadioRow = (label, value) =>
  `<div class="form-row"><div class="form-item full-width"><label class="form-label">${label}</label><span>${value || ""}</span></div></div>`;

const genSubSection = (title) =>
  `<div class="sub-section">${title}</div>`;

export default {
  name: "FinancingForm",
  setup() {
    const submitting = ref(false);

    const formData = reactive({
      // 申请人信息
      name: "",
      gender: "",
      birthDate: "",
      ethnicity: "",
      education: "",
      maritalStatus: "",
      idCard: "",
      householdPlace: "",
      email: "",
      homeAddress: "",
      phone: "",
      workUnit: "",
      unitNature: "",
      unitPhone: "",
      position: "",
      unitAddress: "",
      applyAmount: "",
      applyTerm: "",
      bankAndLoan: "",
      creditCardCount: "",
      totalLimitAndBank: "",
      // 配偶信息
      spouseName: "",
      spousePhone: "",
      // 紧急联系人
      emergency1Name: "",
      emergency1Relation: "",
      emergency1Phone: "",
      emergency2Name: "",
      emergency2Relation: "",
      emergency2Phone: "",
      emergency3Name: "",
      emergency3Relation: "",
      emergency3Phone: "",
      // 经济情况
      propertyAddress: "",
      buildingArea: "",
      monthlyPaymentAndTerm: "",
      purchaseType: "",
      vehicle: "",
      socialSecurity: "",
      socialSecurityBase: "",
      socialSecurityYears: "",
      housingFund: "",
      housingFundAmount: "",
      housingFundYears: "",
      salary: "",
      spouseIncome: "",
      companyInvoice: "",
      externalGuarantee: "",
      insurancePolicy: "",
      propertyNotarization: "",
      creditStatus: "",
      // 贷款用途
      loanReason: "",
      loanAmount: "",
      loanTerm: "",
      guaranteeMethod: "",
      // 接待经理
      managerSign: "",
    });

    const generateHtml = (data) => {
      const section = (title, body) =>
        `<div class="section"><div class="section-title">${title}</div>${body}</div>`;

      const applicantInfo = section("申请人信息",
        genDoubleRow("姓名", data.name, "联系电话", data.phone) +
        genDoubleRow("性别", data.gender, "出生年月", data.birthDate) +
        genDoubleRow("民族", data.ethnicity, "学历", data.education) +
        genDoubleRow("婚姻状况", data.maritalStatus, "身份证号", data.idCard) +
        genDoubleRow("户口所在地", data.householdPlace, "邮箱", data.email) +
        genRow("家庭住址", data.homeAddress) +
        genRow("工作单位", data.workUnit) +
        genDoubleRow("单位性质", data.unitNature, "单位电话", data.unitPhone) +
        genDoubleRow("职务", data.position, "单位地址", data.unitAddress) +
        genDoubleRow("申请金额（万元）", data.applyAmount, "申请期限（月）", data.applyTerm) +
        genDoubleRow("银行及网贷", data.bankAndLoan, "信用卡张数", data.creditCardCount) +
        genRow("总额度及银行", data.totalLimitAndBank)
      );

      const spouseInfo = section("配偶信息",
        genDoubleRow("姓名", data.spouseName, "电话", data.spousePhone)
      );

      const emergencyContact = (n, name, relation, phone) =>
        `<div class="emergency-contact"><div class="emergency-contact-title">联系人 ${n}</div>` +
        genDoubleRow("姓名", name, "关系", relation) +
        genRow("联系电话", phone) +
        `</div>`;

      const emergencyInfo = section("紧急联系人",
        emergencyContact(1, data.emergency1Name, data.emergency1Relation, data.emergency1Phone) +
        emergencyContact(2, data.emergency2Name, data.emergency2Relation, data.emergency2Phone) +
        emergencyContact(3, data.emergency3Name, data.emergency3Relation, data.emergency3Phone)
      );

      const economicInfo = section("经济情况",
        genSubSection("房产情况") +
        genRow("房产地址", data.propertyAddress) +
        genDoubleRow("建筑面积（㎡）", data.buildingArea, "月还款及年限", data.monthlyPaymentAndTerm) +
        genRadioRow("购房方式", data.purchaseType) +
        genSubSection("其他资产") +
        genRow("车产", data.vehicle) +
        genSubSection("社保公积金") +
        genDoubleRow("社保", data.socialSecurity, "基数", data.socialSecurityBase) +
        genRow("年限", data.socialSecurityYears) +
        genDoubleRow("公积金", data.housingFund, "个缴金额", data.housingFundAmount) +
        genRow("年限", data.housingFundYears) +
        genSubSection("收入情况") +
        genDoubleRow("打卡工资", data.salary, "配偶收入", data.spouseIncome) +
        genDoubleRow("公司开票", data.companyInvoice, "对外担保", data.externalGuarantee) +
        genRow("保单", data.insurancePolicy) +
        genRadioRow("是否对婚前后财产归属有公证约定", data.propertyNotarization) +
        genRadioRow("个人征信", data.creditStatus)
      );

      const loanPurpose = section("贷款用途",
        `<div class="loan-purpose">本人因${data.loanReason || ""}需要，向贵公司申请贷款咨询${data.loanAmount || ""}万元，期限${data.loanTerm || ""}个月，担保方式是${data.guaranteeMethod || ""}，请予以考虑。</div>`
      );

      const notes = section("注意事项",
        `<div class="notes-section">` +
        `<div class="note-item"><span class="note-label">面签：</span><span>面签前删除掉手机里有赌博性质的APP、借款APP，面签官会问贷款用途、单位地址、名称、家庭住址等。</span></div>` +
        `<div class="note-item"><span class="note-label">电审：</span><span>电审前确认好手机有无骚扰电话拦截功能，拦截APP有的话一定要关闭、删除。</span></div>` +
        `<div class="note-item"><span class="note-label">下户：</span><span>企业主、股东下户单位，提前给下户核访老师准备好饮料、茶、烟，这是加分项，单位需要有招牌，提前准备好经营往来合同、票据、流水，准备的越齐全越稳。</span></div>` +
        `</div>`
      );

      const manager = section("接待经理",
        genRow("客户经理工号", data.managerSign)
      );

      const style = `<style>
        *{margin:0;padding:0;box-sizing:border-box;}
        body{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif;background:#f5f5f5;padding-bottom:30px;}
        .header{background:linear-gradient(135deg,#667eea 0%,#764ba2 100%);color:white;padding:20px;text-align:center;}
        .header h1{font-size:20px;font-weight:500;}
        .form-container{padding:15px;}
        .section{background:white;border-radius:12px;margin-bottom:15px;overflow:hidden;box-shadow:0 2px 8px rgba(0,0,0,0.06);}
        .section-title{background:#f8f9fa;padding:12px 15px;font-size:15px;font-weight:600;color:#333;border-left:4px solid #667eea;}
        .form-row{display:flex;flex-wrap:wrap;border-bottom:1px solid #f0f0f0;}
        .form-row:last-child{border-bottom:none;}
        .form-item{flex:1;min-width:50%;padding:12px 15px;border-right:1px solid #f0f0f0;}
        .form-item:last-child{border-right:none;}
        .form-item.full-width{min-width:100%;border-right:none;}
        .form-label{font-size:13px;color:#666;margin-bottom:6px;display:block;}
        .form-item span{font-size:14px;color:#333;}
        .emergency-contact{background:#fafafa;margin:10px;border-radius:8px;padding:10px;}
        .emergency-contact-title{font-size:13px;color:#667eea;margin-bottom:10px;font-weight:500;}
        .loan-purpose{padding:15px;font-size:14px;line-height:1.8;color:#333;}
        .notes-section{padding:15px;}
        .note-item{display:flex;margin-bottom:12px;font-size:13px;line-height:1.6;color:#555;}
        .note-item:last-child{margin-bottom:0;}
        .note-label{color:#667eea;font-weight:500;min-width:45px;flex-shrink:0;}
        .sub-section{padding:10px 15px;background:#f8f9fa;font-size:13px;color:#666;font-weight:500;}
      </style>`;

      return `<!DOCTYPE html><html lang="zh-CN"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no"><title>融资资料表</title>${style}</head><body><div class="header"><h1>个人咨询表</h1></div><div class="form-container">${applicantInfo}${spouseInfo}${emergencyInfo}${economicInfo}${loanPurpose}${notes}${manager}</div></body></html>`;
    };

    const handleSubmit = () => {
      submitting.value = true;

      const htmlContent = generateHtml(formData);

      const submitData = {
        name: formData.name,
        mobile: formData.phone,
        no: formData.managerSign,
          html: htmlContent
      };

      postCustomerVisit(submitData)
        .then((res) => {
          if (res.code == 200) {
            ElMessage.success("提交成功！");
            router.push("/customer/visit/success");
          } else {
            ElMessage.error(res.msg || "提交失败");
          }
        })
        .catch(() => {
          ElMessage.error("网络错误，请重试");
        })
        .finally(() => {
          submitting.value = false;
        });
    };

    return {
      formData,
      submitting,
      handleSubmit,
    };
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.financing-form {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 30px;
}

.header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  text-align: center;

  h1 {
    font-size: 20px;
    font-weight: 500;
  }
}

.form-container {
  padding: 15px;
}

.section {
  background: white;
  border-radius: 12px;
  margin-bottom: 15px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.section-title {
  background: #f8f9fa;
  padding: 12px 15px;
  font-size: 15px;
  font-weight: 600;
  color: #333;
  border-left: 4px solid #667eea;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
}

.form-item {
  flex: 1;
  min-width: 50%;
  padding: 12px 15px;
  border-right: 1px solid #f0f0f0;

  &:last-child {
    border-right: none;
  }

  &.full-width {
    min-width: 100%;
    border-right: none;
  }
}

.form-label {
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
  display: block;
}

.form-input {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
  background: #fff;
  color: #333;

  &:focus {
    border-color: #667eea;
  }
}

select.form-input {
  appearance: none;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 8L1 3h10z'/%3E%3C/svg%3E") no-repeat right 10px center;
  padding-right: 30px;
}

.radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.radio-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;

  input[type="radio"] {
    margin-right: 5px;
    width: 16px;
    height: 16px;
    accent-color: #667eea;
  }
}

.emergency-contact {
  background: #fafafa;
  margin: 10px;
  border-radius: 8px;
  padding: 10px;
}

.emergency-contact-title {
  font-size: 13px;
  color: #667eea;
  margin-bottom: 10px;
  font-weight: 500;
}

.loan-purpose {
  padding: 15px;
  font-size: 14px;
  line-height: 1.8;
  color: #333;

  input[type="text"] {
    border: none;
    border-bottom: 1px solid #ddd;
    padding: 2px 5px;
    width: 80px;
    text-align: center;
    font-size: 14px;
    outline: none;
    background: transparent;

    &:focus {
      border-bottom-color: #667eea;
    }
  }
}

.notes-section {
  padding: 15px;
}

.note-item {
  display: flex;
  margin-bottom: 12px;
  font-size: 13px;
  line-height: 1.6;
  color: #555;

  &:last-child {
    margin-bottom: 0;
  }
}

.note-label {
  color: #667eea;
  font-weight: 500;
  min-width: 45px;
  flex-shrink: 0;
}

.signature-row {
  display: flex;
  padding: 15px;
  gap: 15px;
}

.signature-item {
  flex: 1;
}

.signature-label {
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
}

.date-row {
  padding: 0 15px 15px;
  text-align: center;
  font-size: 14px;
  color: #666;

  input {
    border: none;
    border-bottom: 1px solid #ddd;
    padding: 2px 8px;
    width: 50px;
    text-align: center;
    font-size: 14px;
    outline: none;
    background: transparent;

    &:focus {
      border-bottom-color: #667eea;
    }
  }
}

.sub-section {
  padding: 10px 15px;
  background: #f8f9fa;
  font-size: 13px;
  color: #666;
  font-weight: 500;
}

.submit-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 15px;
  border-radius: 25px;
  font-size: 16px;
  width: calc(100% - 30px);
  margin: 0 15px;
  cursor: pointer;

  &:active {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>
